import { format, isEqual } from "date-fns";
import { IExcludedDay } from "src/Pages/Company/Absences/Calendars/Calendars.models";

/**
 * Function determining if given day should be greyed out in datepicker.
 * Checks if it is present in excluded days configured on yearly calendar.
 * @param {Date} date - current date.
 * @param {array} excludedDays - collection of excluded days from yearly calendar.
 * @returns {boolean}
 */
export default (date: Date, excludedDays: IExcludedDay[]) => {
  const parsedToISO = format(new Date(date), "yyyy-MM-dd");
  const isExcluded = excludedDays.some((day) => day.date === parsedToISO);

  return isExcluded;
};
